import { useRef, useState } from "react";

const useDragToScroll = (scrollContainerRef) => {
  if (!scrollContainerRef) {
    scrollContainerRef = useRef(null);
  }
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    const scrollContainer = scrollContainerRef.current;
    setIsDragging(true);
    setStartX(e.pageX - scrollContainer.offsetLeft);
    setScrollLeft(scrollContainer.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const scrollContainer = scrollContainerRef.current;
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    scrollContainer.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e) => {
    const scrollContainer = scrollContainerRef.current;
    setIsDragging(true);
    setStartX(e.touches[0].pageX - scrollContainer.offsetLeft);
    setScrollLeft(scrollContainer.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const scrollContainer = scrollContainerRef.current;
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2;
    scrollContainer.scrollLeft = scrollLeft - walk;
  };

  // Hook returns the reference and handlers
  return {
    scrollContainerRef,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    handleTouchStart,
    handleTouchMove,
    isDragging,
  };
};

export default useDragToScroll;
//USAGE:

// const {
//   scrollContainerRef,
//   handleMouseDown,
//   handleMouseLeave,
//   handleMouseUp,
//   handleMouseMove,
//   handleTouchStart,
//   handleTouchMove,
//   isDragging
// } = useDragToScroll();

// return (
//   <div
//     className="scroll-container"
//     ref={scrollContainerRef}
//     onMouseDown={handleMouseDown}
//     onMouseLeave={handleMouseLeave}
//     onMouseUp={handleMouseUp}
//     onMouseMove={handleMouseMove}
//     onTouchStart={handleTouchStart}
//     onTouchMove={handleTouchMove}
//   >
//     <div className="scroll-content">
//       <div className="item">Item 1</div>
//       <div className="item">Item 2</div>
//       <div className="item">Item 3</div>
//       <div className="item">Item 4</div>
//       {/* Add more items here */}
//     </div>
//   </div>
// );
